/* global $ */
import dynamicList from './modules/DynamicList';
import autocompleteSearch from './modules/AutocompleteSearch';
import searchBox from './modules/SearchBox';
import colorPicker from './modules/ColorPicker';
import managedForm from './modules/ManagedForm';
import salaryTab from './modules/SalaryTab';
import alternativeKeywords from './modules/AlternativeKeywords';

import './vendor/bootstrap-tagsinput';

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
  },
});

const components = {
  DynamicList: dynamicList,
  AutocompleteSearch: autocompleteSearch,
  SearchBox: searchBox,
  ColorPicker: colorPicker,
  ManagedForm: managedForm,
  SalaryTab: salaryTab,
  AlternativeKeywords: alternativeKeywords,
};

function check() {
  let customElements = document.querySelectorAll('[data-custom-component]');
  customElements = Array.prototype.slice.call(customElements);

  customElements.forEach((el) => {
    if (el.className.indexOf('is-initialized') >= 0) {
      return;
    }

    const { customComponent } = el.dataset;
    const inst = { ...components[customComponent] };
    inst.create(el, el.dataset);

    el.className += ' is-initialized';
  });
}

check();

window.pubsub.subscribe('components:evaluate', check);
